<template>
  <div class="order-card-2">
    <!-- header -->
    <el-row :gutter="20" class="card__header">
      <el-col
        :xs="24"
        :sm="24"
        :md="colSpan"
        :lg="colSpan"
        :xl="colSpan"
        class="card__header-col "
        :class="{ 'card__header-col-1': !isMobile }"
      >
        <span class="label">承兑人名称：</span>
        <span class="value" :title="data.acceptor">{{ data.acceptor }}</span>
      </el-col>
      <el-col
        :xs="24"
        :sm="24"
        :md="8"
        :lg="8"
        :xl="8"
        class="card__header-col "
        :class="{ 'card__header-col-2': !isMobile }"
      >
        <span class="label">企业名称：</span>
        <span class="value" :title="data.entname">{{ data.entname }}</span>
      </el-col>
      <el-col
        :xs="24"
        :sm="24"
        :md="colSpan"
        :lg="colSpan"
        :xl="colSpan"
        class="card__header-col "
        :class="{ 'card__header-col-3': !isMobile }"
      >
        <span class="label" v-show="!refused">计划放款日期：</span>
        <span class="value" v-show="!refused" :title="data.repaydate">{{ data.repaydate }}</span>
      </el-col>
      <el-col
        v-if="hasCreateDate"
        :xs="24"
        :sm="24"
        :md="colSpan"
        :lg="colSpan"
        :xl="colSpan"
        class="card__header-col "
        :class="{ 'card__header-col-4': !isMobile }"
      >
        <span class="label">询价时间：</span>
        <span class="value" :title="data.createdate">{{
          data.createdate
        }}</span>
      </el-col>
    </el-row>
    <!-- body -->
    <div class="card__body">
      <!-- 正常记录 -->
      <el-row v-if="!refused" :gutter="20">
        <el-col
          :xs="12"
          :sm="12"
          :md="6"
          :lg="6"
          :xl="6"
          class="card__body-col"
        >
          <span class="label">票面金额</span>
          <span class="value">{{ data.billamount }}</span>
        </el-col>
        <el-col
          :xs="12"
          :sm="12"
          :md="6"
          :lg="6"
          :xl="6"
          class="card__body-col"
        >
          <span class="label">拟融资费用</span>
          <span class="value">{{ data.creditamount }}</span>
        </el-col>
        <el-col
          :xs="12"
          :sm="12"
          :md="6"
          :lg="6"
          :xl="6"
          class="card__body-col"
        >
          <span class="label">拟放款金额</span>
          <span class="value">{{ data.loanamount }}</span>
        </el-col>
        <el-col
          :xs="12"
          :sm="12"
          :md="6"
          :lg="6"
          :xl="6"
          class="card__body-col"
        >
          <span class="label">融资年化利率</span>
          <span class="value">{{ data.yearrate }}%</span>
        </el-col>
      </el-row>
      <!-- 异常记录 -->
      <el-row v-else :gutter="20">
        <el-col
          :xs="12"
          :sm="12"
          :md="8"
          :lg="8"
          :xl="8"
          class="card__body-col"
        >
          <span class="label">票面金额</span>
          <span class="value">{{ data.billamount || "-" }}</span>
        </el-col>
        <el-col
          :xs="12"
          :sm="12"
          :md="16"
          :lg="16"
          :xl="16"
          class="card__body-col"
        >
          <span class="label">拒绝原因</span>
          <span class="value">{{ data.refusereason }}</span>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

export default {
  props: {
    hasCreateDate: {
      default: false
    },
    data: {
      default: () => ({
        acceptor: "",
        entname: "",
        repaydate: "",
        billamount: "",
        creditamount: "",
        loanamount: "",
        yearrate: ""
      })
    }
  },
  computed: {
    ...mapGetters(["isMobile"]),
    refused() {
      return Number(this.data.status) === -1;
    },
    colSpan() {
      return this.refused ? 6 : 8;
    }
  },
  methods: {}
};
</script>

<style lang="scss">
.order-card-2 {
  /*border: solid 1px #eee;*/
  border-radius: 4px;
  /*display: flex;*/
  /*flex-direction: column;*/
  /*height: 154px;*/
  box-sizing: border-box;

  .el-row {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .card__header {
    /*display: flex;*/
    /*flex-wrap: wrap;*/
    /*justify-content: space-between;*/
    /*align-items: center;*/
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding: 10px;
    font-size: 13px;
    color: #666;
    /*background: #fafafa;*/

    .card__header-col {
      /*margin-right: 10px;*/
      height: 24px;
      line-height: 24px;
      @extend .text-overflow;
    }

    .card__header-col-1 {
      /*width: 30%;*/
    }

    .card__header-col-2 {
      /*width: 30%;*/
    }

    .card__header-col-3 {
      /*width: 20%;*/
    }

    .card__header-col-4 {
      /*width: 20%;*/
    }
  }

  .card__body {
    /*display: flex;*/
    /*flex-wrap: wrap;*/
    /*justify-content: space-between;*/
    /*height: calc(100% - 40px);*/

    .card__body-col {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-left: 0 !important;
      padding-right: 0 !important;
      padding: 10px;
      /*width: 25%;*/
      box-sizing: border-box;
      border-top: solid 1px #eee;
      border-left: solid 1px #eee;

      &.card__body-col-3 {
        width: 75%;
      }

      &.full-line {
        width: 100%;
      }

      &:nth-child(1) {
        border-left: 0;
      }

      .label {
        font-size: 14px;
        color: #666;
      }

      .value {
        margin-top: 10px;
        font-size: 20px;
        color: $high;

        &.error {
          font-size: 15px;
          color: #f00;
        }
      }
    }

    .error-info {
      color: #f00;
      font-size: 24px;
    }
  }
}

// xs
@media only screen and (max-width: 767px) {
  .order-card-2 {
    border: 0;

    .card__header {
      padding: 10px 0;
      background: transparent;
    }

    .card__body {
      background: #f6faf9;

      .card__body-col {
        border: 0;
      }
    }
  }
}

// md
@media only screen and (min-width: 992px) {
  .order-card-2 {
    border: solid 1px #eee;

    .card__header {
      padding: 10px;
      background: #fafafa;
    }
  }
}

</style>
